






















import { Component, Prop, Vue } from "vue-property-decorator";
import ShopifyBuy, { Product, Client, Checkout, CheckoutLineItem } from "shopify-buy";
import Collection from "@/components/shop/Collection.vue";
import { shopify as config } from "@/config";
import Store from "@/app/store/Store";
import { UserType, PurchasesType } from "@/types";

@Component({ components: { Collection } })
export default class Shop extends Vue {
  @Prop({ required: false }) purchases?: PurchasesType;
  @Prop({ required: true }) user!: UserType;

  loading = false;

  checkout: typeof Checkout | null = null;
  checkoutId: string | null = null;
  client: typeof Client | null = null;
  products: typeof Product[] = [];

  get purchasedVariantIds() {
    return this.purchases ? Object.keys(this.purchases) : [];
  }

  addToCheckout(variantId: string, quantity: number): void {
    if (!this.client) return;

    this.loading = true;
    if (!this.checkout) {
      this.createCheckout(() => this.addToCheckout(variantId, quantity));
      return;
    }

    this.client.checkout
      .addLineItems(this.checkout.id, [{ variantId, quantity }])
      .then((checkout: typeof Checkout) => {
        this.setCheckout(checkout);
        this.loading = false;
      });
  }
  removeFromCheckout(variantId: string): void {
    if (!this.client || !this.checkout) return;

    this.loading = true;

    const lineItem = this.checkout.lineItems.filter(
      (lineItem: typeof CheckoutLineItem) => lineItem.variant.id === variantId
    )[0];
    if (!lineItem) return;

    this.client.checkout
      .updateLineItems(this.checkout.id, [{ id: lineItem.id, quantity: 0 }])
      .then((checkout: typeof Checkout) => {
        this.setCheckout(checkout);
        this.loading = false;
      });
  }

  createCheckout(callback?: () => void) {
    if (this.checkout || !this.client) return;
    if (this.checkoutId) return this.fetchCheckout(callback, true);
    return this.client.checkout.create().then((checkout: typeof Checkout) => {
      this.client?.checkout
        .updateAttributes(checkout.id, {
          customAttributes: [{ key: "firebaseUserId", value: this.user.uid }],
        })
        .then((checkout: typeof Checkout) => {
          this.setCheckout(checkout);
          if (callback) callback();
        });
    });
  }

  fetchCheckout(callback?: () => void, create = false) {
    if (!this.client || !this.checkoutId) return;
    this.client.checkout
      .fetch(this.checkoutId)
      .then((checkout: typeof Checkout) => {
        if (checkout && !checkout.completedAt) {
          this.setCheckout(checkout);
          if (callback) callback();
        } else {
          this.setCheckoutId(null);
          if (create) this.createCheckout(callback);
        }
      })
      .catch(() => {
        this.setCheckoutId(null);
        this.createCheckout(callback);
      });
  }

  setCheckout(checkout: typeof Checkout) {
    this.setCheckoutId(checkout.id);
    this.checkout = checkout;
  }

  setCheckoutId(id?: string | null) {
    if (id) {
      Store.local.checkoutId.set(id.toString());
      this.checkoutId = id.toString();
    } else {
      if (this.checkoutId) Store.local.checkoutId.remove();
      this.checkoutId = null;
    }
  }

  mounted() {
    if (!this.client) this.client = ShopifyBuy.buildClient(config);
    this.setCheckoutId(Store.local.checkoutId.read());
    if (this.checkoutId) {
      this.loading = true;
      this.fetchCheckout(() => (this.loading = false));
    }
    // TODO: fetch a collection instead of all products
    if (this.client)
      this.client.product.fetchAll().then((products: typeof Product[]) => {
        products.forEach((product: typeof Product) => this.products.push(product));
      });
  }
}
